import { PromotionStateTypes, PromotionActionTypes } from "./Promotion.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PromotionStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PromotionReducer = (
  state: PromotionStateTypes = INITIAL_STATE,
  action: any
): PromotionStateTypes => {
  switch (action.type) {
    case PromotionActionTypes.FETCH_ALL_PROMOTION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PromotionActionTypes.FETCH_ALL_PROMOTION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PromotionActionTypes.FETCH_ALL_PROMOTION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PromotionActionTypes.FETCH_ALL_PROMOTION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PromotionActionTypes.FETCH_ONE_PROMOTION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PromotionActionTypes.FETCH_ONE_PROMOTION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case PromotionActionTypes.FETCH_ONE_PROMOTION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PromotionActionTypes.FETCH_ONE_PROMOTION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PromotionReducer;
